import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const categoryValidation = yupResolver(
  yup.object().shape({
    name: yup.string().required("Name is a required field"),
    faq_link: yup.string().url("FAQ link is invalid").nullable(),
  }),
);
